// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CSSToolTip {
  display: inline-block;
  margin-left: 5px;
  height: 17px;
  width: 17px;
  position: relative;
}
.CSSToolTip .zervant-icon {
  cursor: pointer;
}
.CSSToolTip:hover .CSSToolTip__container {
  visibility: visible;
  opacity: 1;
}
.CSSToolTip__header {
  font-size: 12px !important;
  font-weight: 600;
  margin-bottom: 10px;
}
.CSSToolTip__body {
  width: 100%;
  font-size: 12px !important;
  line-height: 17px;
  color: #697588;
  white-space: normal;
}
.CSSToolTip__body b {
  color: #002E33;
}
.CSSToolTip__container {
  opacity: 0;
  visibility: hidden;
  width: 300px;
  -webkit-transition: opacity 0.2s ease-in-out;
  transition: opacity 0.2s ease-in-out;
  padding: 12px;
  border-radius: 4px;
  height: auto;
  background-color: #FFF;
  color: #002E33;
  -webkit-box-shadow: 0 1px 4px 1px rgba(38, 40, 47, 0.15);
          box-shadow: 0 1px 4px 1px rgba(38, 40, 47, 0.15);
  position: absolute;
  z-index: 1;
}
.CSSToolTip__container .__arrow {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  cursor: pointer;
}
.CSSToolTip__container .__arrow i {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 0;
  height: 0;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  border: 6px solid;
  border-color: transparent transparent #FFF #FFF;
  position: relative;
  -webkit-box-shadow: -2px 3px 5px 0 #E8E9F0;
          box-shadow: -2px 3px 5px 0 #E8E9F0;
}
.CSSToolTip__container--top {
  -webkit-transform: translateX(-118px) translateY(calc(-100% - 31px));
          transform: translateX(-118px) translateY(calc(-100% - 31px));
}
.CSSToolTip__container--top .__arrow {
  position: absolute;
  bottom: -21px;
  left: 0;
  width: 100%;
  height: 20px;
}
.CSSToolTip__container--top .__arrow i {
  left: 120px;
  top: -7px;
  -webkit-transform: rotate(-45deg);
          transform: rotate(-45deg);
}
.CSSToolTip__container--right {
  -webkit-transform: translateX(30px) translateY(calc(-50% - 11px));
          transform: translateX(30px) translateY(calc(-50% - 11px));
}
.CSSToolTip__container--right .__arrow {
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  position: absolute;
  top: 0;
  left: -20px;
  height: 100%;
  width: 20px;
}
.CSSToolTip__container--right .__arrow i {
  top: 3px;
  left: 10px;
  -webkit-transform: rotate(45deg);
          transform: rotate(45deg);
}
.CSSToolTip__container--left {
  -webkit-transform: translateX(calc(-100% - 14px)) translateY(calc(-50% - 11px));
          transform: translateX(calc(-100% - 14px)) translateY(calc(-50% - 11px));
}
.CSSToolTip__container--left .__arrow {
  -webkit-box-pack: left;
      -ms-flex-pack: left;
          justify-content: left;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  position: absolute;
  top: 0;
  right: -21px;
  height: 100%;
  width: 20px;
}
.CSSToolTip__container--left .__arrow i {
  right: 7px;
  top: 3px;
  -webkit-transform: rotate(225deg);
          transform: rotate(225deg);
}
.CSSToolTip__container--bottom {
  -webkit-transform: translateX(-118px) translateY(14px);
          transform: translateX(-118px) translateY(14px);
}
.CSSToolTip__container--bottom .__arrow {
  position: absolute;
  top: -21px;
  left: 0;
  width: 100%;
  height: 20px;
}
.CSSToolTip__container--bottom .__arrow i {
  left: 120px;
  bottom: -15px;
  -webkit-transform: rotate(135deg);
          transform: rotate(135deg);
}

.absolute {
  font-size: 12px;
  top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/CSSToolTip/CSSToolTip.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AADF;AAGE;EACE,eAAA;AADJ;AAKI;EACE,mBAAA;EACA,UAAA;AAHN;AAOE;EACE,0BAAA;EACA,gBAAA;EACA,mBAAA;AALJ;AAQE;EACE,WAAA;EACA,0BAAA;EACA,iBAAA;EACA,cCuBK;EDtBL,mBAAA;AANJ;AAQI;EACE,cChCS;AD0Bf;AAaE;EACE,UAAA;EACA,kBAAA;EACA,YAAA;EAEA,4CAAA;EAAA,oCAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,sBC1CI;ED2CJ,cCjDW;EDkDX,wDAAA;UAAA,gDAAA;EACA,kBAAA;EACA,UAAA;AAZJ;AAcI;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,eAAA;AAZN;AAcM;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iBAAA;EACA,+CAAA;EACA,kBAAA;EACA,0CAAA;UAAA,kCAAA;AAZR;AAgBI;EACE,oEAAA;UAAA,4DAAA;AAdN;AAgBM;EACE,kBAAA;EACA,aAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AAdR;AAgBQ;EACE,WAAA;EACA,SAAA;EACA,iCAAA;UAAA,yBAAA;AAdV;AAmBI;EACE,iEAAA;UAAA,yDAAA;AAjBN;AAmBM;EACE,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAjBR;AAmBQ;EACE,QAAA;EACA,UAAA;EACA,gCAAA;UAAA,wBAAA;AAjBV;AAsBI;EACE,+EAAA;UAAA,uEAAA;AApBN;AAsBM;EACE,sBAAA;MAAA,mBAAA;UAAA,qBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AApBR;AAsBQ;EACE,UAAA;EACA,QAAA;EACA,iCAAA;UAAA,yBAAA;AApBV;AAyBI;EACE,sDAAA;UAAA,8CAAA;AAvBN;AAyBM;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AAvBR;AAyBQ;EACE,WAAA;EACA,aAAA;EACA,iCAAA;UAAA,yBAAA;AAvBV;;AA8BA;EACE,eAAA;EACA,QAAA;AA3BF","sourcesContent":["@import '../../../Global/Colors.scss';\n\n.CSSToolTip {\n  display: inline-block;\n  margin-left: 5px;\n  height: 17px;\n  width: 17px;\n  position: relative;\n\n  .zervant-icon {\n    cursor: pointer;\n  }\n\n  &:hover {\n    .CSSToolTip__container {\n      visibility: visible;\n      opacity: 1;\n    }\n  }\n\n  &__header {\n    font-size: 12px !important;\n    font-weight: 600;\n    margin-bottom: 10px;\n  }\n\n  &__body {\n    width: 100%;\n    font-size: 12px !important;\n    line-height: 17px;\n    color: $Gray90;\n    white-space: normal;\n\n    b {\n      color: $DeepSeaGreen;\n    }\n  }\n\n  $shift: 76px;\n  $triangle: 14px;\n\n  &__container {\n    opacity: 0;\n    visibility: hidden;\n    width: 300px;\n\n    transition: opacity 0.2s ease-in-out;\n    padding: 12px;\n    border-radius: 4px;\n    height: auto;\n    background-color: $White;\n    color: $DeepSeaGreen;\n    box-shadow: 0 1px 4px 1px rgba($Gray200, 0.15);\n    position: absolute;\n    z-index: 1;\n\n    .__arrow {\n      display: flex;\n      cursor: pointer;\n\n      i {\n        display: flex;\n        width: 0;\n        height: 0;\n        box-sizing: border-box;\n        border: 6px solid;\n        border-color: transparent transparent $White $White;\n        position: relative;\n        box-shadow: -2px 3px 5px 0 $Gray30;\n      }\n    }\n\n    &--top {\n      transform: translateX(-118px) translateY(calc(-100% - 31px));\n\n      .__arrow {\n        position: absolute;\n        bottom: -21px;\n        left: 0;\n        width: 100%;\n        height: 20px;\n\n        i {\n          left: 120px;\n          top: -7px;\n          transform: rotate(-45deg);\n        }\n      }\n    }\n\n    &--right {\n      transform: translateX(30px) translateY(calc(-50% - 11px));\n\n      .__arrow {\n        justify-content: center;\n        align-items: center;\n        position: absolute;\n        top: 0;\n        left: -20px;\n        height: 100%;\n        width: 20px;\n\n        i {\n          top: 3px;\n          left: 10px;\n          transform: rotate(45deg);\n        }\n      }\n    }\n\n    &--left {\n      transform: translateX(calc(-100% - 14px)) translateY(calc(-50% - 11px));\n\n      .__arrow {\n        justify-content: left;\n        align-items: center;\n        position: absolute;\n        top: 0;\n        right: -21px;\n        height: 100%;\n        width: 20px;\n\n        i {\n          right: 7px;\n          top: 3px;\n          transform: rotate(225deg);\n        }\n      }\n    }\n\n    &--bottom {\n      transform: translateX(-118px) translateY(14px);\n\n      .__arrow {\n        position: absolute;\n        top: -21px;\n        left: 0;\n        width: 100%;\n        height: 20px;\n\n        i {\n          left: 120px;\n          bottom: -15px;\n          transform: rotate(135deg);\n        }\n      }\n    }\n  }\n}\n\n.absolute {\n  font-size: 12px;\n  top: 4px;\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
